// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__dVIF8","bigColWidth":"Table_bigColWidth__1lEfD","biggerColWidth":"Table_biggerColWidth__wcBN_","row":"Table_row__3QwPo","col":"Table_col__1uLVv"};